import Cookies from "js-cookie";

let GDPR = {

    activeGtag: function () {
        let dataset = document.getElementById('tr-gtag');
        if( null != dataset ) {
            window.dataLayer = window.dataLayer || [];
            function gtag(){window.dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', dataset.dataset.gtag);
        }
    },

    activeAnalytics: function () {
        let dataset = document.getElementById('tr-analytic');
        if( null != dataset ) {
            window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;
            ga('create', dataset.dataset.analytic, 'auto');
            ga('send', 'pageview');
        }
    },

    activePixel: function () {
        if( typeof window.fbq === "function" ) {
            window.fbq('consent', 'grant');
        }
    },

    activeAll: function () {
        GDPR.activeGtag();
        GDPR.activeAnalytics()
        GDPR.activePixel();
    },

    setOnclick: function () {
        let btn = document.querySelector('#gdpr-activate')
        if( null != btn ) {
            btn.addEventListener('click', function (event) {
                Cookies.set('_gdpr', 'true', { expires: 365 }); /** We set cookies to save the acceptation */
                GDPR.activeAll();
            });
        }
    },

    run : function () {
        if( 'true' === Cookies.get('_gdpr') ) {
            GDPR.activeAll()
        }

        GDPR.setOnclick();
    }

}

export default GDPR;
